import type { InjectionKey } from 'vue'
import type { LineType } from './types'
export interface TimelineContext {
  reverse: boolean
  parentCls: string
  count: number
  lineType: LineType
}

/**
 * @description 之所以命名为context从行为上讲Provide和Inject形似上下文
 */
export const timelineInjectionKey: InjectionKey<TimelineContext> = Symbol('timelineKey')
